/* eslint-disable no-unused-vars */
import Repository from '../../repositories/RepositoryFactory';

const InvoicesRepository = Repository.get('invoices');

export default {
	namespaced: true,
	state: {
		allInvoices: [],
		allInvoicesForOrganization: null,
		invoiceById: null,
		invoiceReferencesForOrganization: null,
		generatedPdfFile: null,
		contactEmails: [],
	},
	mutations: {
		GET_INVOICES (state, payload) {
			state.allInvoices = payload.data;
		},
		GET_INVOICE_BY_ID (state, payload) {
			state.invoiceById = payload;
		},
		GET_RELATED_INVOICES_FOR_ORGANIZATION (state, payload) {
			state.allInvoicesForOrganization = payload.data.usersRelatedToHospital;
		},
		GET_INVOICE_REFERENCES_FOR_ORGANIZATION (state, payload) {
			state.invoiceReferencesForOrganization = payload.data;
		},
		GET_PDF_FOR_INVOICE_ID (state, payload) {
			state.generatedPdfFile = payload;
		},
		SET_CONTACT_INVOICES_EMAILS (state, payload) {
			state.contactEmails = payload;
		},
		UPDATE_INVOICE_IN_LIST (state, payload) {
			const index = state.allInvoices.findIndex((invoice) => invoice.id === payload.id);
			if (index !== -1) {
				state.allInvoices.splice(index, 1, payload);
			}
		},
	},
	actions: {
		async getInvoiceReferencesForOrganization ({ commit }, organizationId) {
			const response = await InvoicesRepository.getInvoiceReferencesForOrganization(organizationId);
			// commit('GET_INVOICE_REFERENCES_FOR_ORGANIZATION', await InvoicesRepository.getInvoiceReferencesForOrganization(organizationId));
			commit('GET_INVOICE_REFERENCES_FOR_ORGANIZATION', response);
			return response;
		},
		async getInvoices ({ commit }) {
			commit('GET_INVOICES', await InvoicesRepository.getInvoices());
		},
		async generateInvoiceForOrganization ({ commit }, body) {
			const res = await InvoicesRepository.generateInvoiceForOrganization(body);
			return res;
		},
		async updateInvoiceForOrganization ({ commit }, body) {
			const res = await InvoicesRepository.updateInvoiceForOrganization(body);
			return res;
		},
		async getInvoicePdf ({ commit }, object) {
			commit('GET_PDF_FOR_INVOICE_ID', await InvoicesRepository.getInvoicePdf(object));
		},
		async deleteInvoiceById ({ commit }, id) {
			const res = await InvoicesRepository.deleteInvoice(id);
			return res;
		},
		async getContactInvoicesEmails ({ commit }, id) {
			commit('SET_CONTACT_INVOICES_EMAILS', await InvoicesRepository.getContactInvoicesEmails(id));
		},
		async sendInvoiceByMailById ({ commit }, object) {
			commit('UPDATE_INVOICE_IN_LIST', await InvoicesRepository.sendInvoiceByMailById(object.id, object.toEmails));
		},
		async changeInvoiceStatus ({ commit }, object) {
			commit(
				'UPDATE_INVOICE_IN_LIST',
				await InvoicesRepository.changeInvoiceStatus(object.invoiceId, object.invoiceStatus),
			);
		},
		async sendMultipleAttachmentsByMail ({ commit }, object) {
			return await InvoicesRepository.sendMultipleAttachmentsByMail(object);
		},
	},
	getters: {},
};
